import { ParsedQuery } from 'query-string';
import { ProjectId, TaskId, TaskIdV2 } from 'api/models';
import { Transformer } from 'hooks/use-hash';
import {
  parseTaskDrawerParam,
  stringifyTaskDrawerParam,
} from 'hooks/use-navigate-to-task';

type Show = ['show', ProjectId, TaskIdV2];
type Invalid = ['invalid'];

export type TaskDrawerParams = Show | Invalid;

export const transformer: Transformer<TaskDrawerParams> = {
  from: (parsed) => {
    if (typeof parsed.task_drawer !== 'string') {
      return ['invalid'];
    }

    const groups = parseTaskDrawerParam(parsed.task_drawer);

    if (!groups) {
      return ['invalid'];
    }
    const { project_id, task_id } = groups;

    return ['show', ProjectId(project_id), TaskIdV2(task_id)];
  },
  to: (params): ParsedQuery => {
    switch (params[0]) {
      case 'show':
        return {
          task_drawer: stringifyTaskDrawerParam(
            TaskId(params[1][1], params[2][1]),
          ),
        };
      default:
        return {
          task_drawer: null,
          task_drawer_tab: null,
          form_response_id: null,
        };
    }
  },
};
